<template>
  <div class="cube-input x-input-phone">
    <input
      v-if="renderSence === 'edit'"
      class="cube-input-field"
      v-model="inputValue"
      v-bind="$attrs"
      type="tel"
      maxlength="13"
    >
    <input v-else-if="renderSence === 'read'" class="cube-input-field text-overflow" readonly :value="inputValue || '-'" />
  </div>
</template>

<script>
import PhoneUtil from '@/lib/ui/utils/phone.util.js'

export default {
  name: 'XInputPhone',
  props: {
    value: {
      type: [String],
      requried: true
    },
    renderSence: {
      type: String,
      default: 'edit',
      validator(value) {
        return ['edit', 'read'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.formatPhone(this.value)
      },
      set(value) {
        let number = this.formatNumber(value)
        this.$emit('input', number)
        console.log(number)
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    }
  },
  methods: {
    formatNumber(value) {
      let result = PhoneUtil.isPhone(value)
      return result === false ? value : result
    },
    formatPhone(value) {
      return PhoneUtil.formatPhone(value)
    }
  }
}
</script>

<style lang="scss">

</style>